import React, {useState} from 'react';
import Grid from "@mui/material/Grid2";
import Box from "@mui/material/Box";
import {Paper} from "@mui/material";
import ColorPicker from "../../components/colorPicker/ColorPicker";

function ColorsParam({id, values, onChange, value, forCart, props}) {
    const {customColorEnabled} = props || {};
    const [open, setOpen] = useState(false);

    const addColor = (color) => {
        setOpen(false);
        onChange(id, {code: color, custom: true});
    }

    return (forCart ?
            <Paper sx={{width: '16px', height: '16px', backgroundColor: value?.code, borderRadius: '50%'}}
                   elevation={2}/> :
            <Grid container className={"colors-param-container"} justifyContent={{sx: 'initial', md: 'flex-end'}}>
                {values.map(color => <Grid key={color.code} onClick={() => onChange(id, color)}>
                    <Box sx={{
                        cursor: 'pointer',
                        border: '2px solid',
                        padding: '3px',
                        borderRadius: '50%',
                        borderColor: (color.code === value.code ? 'secondary.main' : 'transparent')
                    }}>
                        <Paper sx={{width: '26px', height: '26px', backgroundColor: color.code, borderRadius: '50%'}}
                               elevation={2}/>
                    </Box>
                </Grid>)}
                {customColorEnabled && <Grid key={'add'}>
                    <Box sx={{
                        cursor: 'pointer',
                        border: '2px solid',
                        padding: '3px',
                        borderRadius: '50%',
                        borderColor: (value.custom ? 'secondary.main' : 'transparent')
                    }}>
                        {value.custom ? <Paper onClick={() => setOpen(true)} sx={{
                                width: '26px',
                                height: '26px',
                                backgroundColor: value.code,
                                borderRadius: '50%'
                            }} elevation={2}/> :
                            <Paper onClick={() => setOpen(true)} sx={{
                                width: '26px', height: '26px', background: 'linear-gradient(' +
                                    '90deg,' +
                                    'rgba(255, 0, 0, 1) 0%,' +
                                    'rgba(255, 154, 0, 1) 10%,' +
                                    'rgba(208, 222, 33, 1) 20%,' +
                                    'rgba(79, 220, 74, 1) 30%,' +
                                    'rgba(63, 218, 216, 1) 40%,' +
                                    'rgba(47, 201, 226, 1) 50%,' +
                                    'rgba(28, 127, 238, 1) 60%,' +
                                    'rgba(95, 21, 242, 1) 70%,' +
                                    'rgba(186, 12, 248, 1) 80%,' +
                                    'rgba(251, 7, 217, 1) 90%,' +
                                    'rgba(255, 0, 0, 1) 100%' +
                                    '    )', borderRadius: '50%'
                            }} elevation={2}/>}
                        <ColorPicker onSubmit={addColor} open={open} onClose={() => setOpen(false)}/>
                    </Box>
                </Grid>}
            </Grid>
    );
}

export default ColorsParam;
